import React from 'react';
import { LazyLoadMedia } from 'src/ui/common/organisms/lazy-load-media';
import {
    StyledCreatorName,
    StyledInfo,
    StyledName,
    StyledPrices,
    StyledWrapper
} from './nft-card-preloader.styles';

export const NftCardPreloader = () => (
    <StyledWrapper>
        <LazyLoadMedia />
        <StyledInfo>
            <StyledCreatorName />
            <StyledName />
            <StyledPrices />
        </StyledInfo>
    </StyledWrapper>
);
